import Vue from 'vue'
import VueI18n from 'vue-i18n'
import axios from 'axios'
import * as messages from '../../public/i18n/en.json'

Vue.use(VueI18n)

const defaultLang = 'en';
export const supportedLanguages = ['en', 'fr', 'es'];

console.log(`[I18n] initialized. Default language '${defaultLang}'`);
export const i18n = new VueI18n({
	locale: defaultLang, 
	fallbackLocale: defaultLang,
	messages: { 
		[defaultLang]: messages.default	
	}
})

export async function setI18nLanguage(lang) {
	const loadedLanguages = Object.keys(i18n.messages);
	if (!loadedLanguages.includes(lang)){
		try{
			console.log(`[I18n] loading language '${lang}'`);
			let msgs = await axios.get(`/i18n/${lang}.json`);
			i18n.setLocaleMessage(lang, msgs.data);			
			console.log(`[I18n] loaded language '${lang}'`);
		}
		catch(err){
			console.error(`[I18n] failed to load language '${lang}'`, err);		
		}				
	}	

	if (i18n.locale === lang)
		return lang;

	i18n.locale = lang;
	localStorage["lang"] = lang;
	axios.defaults.headers.common['Accept-Language'] = lang;
	document.querySelector('html').setAttribute('lang', lang);
	return lang;
}

export async function trySetUserLanguage() {
	var userLanguage = localStorage["lang"] || getUserTwoLetterLanguage();

	if (supportedLanguages.includes(userLanguage))
	{
		console.log(`[I18n] user language '${userLanguage}'. Using language '${userLanguage}'.`);
		await setI18nLanguage(userLanguage);
	}
	else
	{
		console.log(`[I18n] user language '${userLanguage}' is not supported. Using default language '${defaultLang}'.`);
		await setI18nLanguage(defaultLang);
	}
}

function getUserTwoLetterLanguage(){
	let userLanguage = (navigator.languages && navigator.languages.length) ? navigator.languages[0] : navigator.language
	userLanguage = userLanguage && userLanguage.split('-')[0];
	return userLanguage;
}